// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Wl-z","badgeLink":"Xl-z","category":"Yl-z"};